import { ShieldCheck, Sparkles, CircleDashed, BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { TIER_META } from "@/hooks/useProfileCompletion";

interface Props {
  tier: 0 | 1 | 2 | 3;
  size?: "sm" | "md";
  className?: string;
  hideOnZero?: boolean;
}

const TONE_CLASS: Record<string, string> = {
  muted: "bg-muted text-muted-foreground border-border",
  sage: "bg-primary/10 text-primary border-primary/30",
  filled: "bg-primary text-primary-foreground border-primary",
  accent: "bg-amber-500/15 text-amber-300 border-amber-500/40",
};

const ICONS = {
  0: CircleDashed,
  1: ShieldCheck,
  2: BadgeCheck,
  3: Sparkles,
} as const;

const CompletionBadge = ({ tier, size = "md", className, hideOnZero }: Props) => {
  if (hideOnZero && tier === 0) return null;
  const meta = TIER_META[tier];
  const Icon = ICONS[tier];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-medium",
        TONE_CLASS[meta.tone],
        size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs",
        className,
      )}
      title={meta.label}
    >
      <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {meta.chipLabel}
    </span>
  );
};

export default CompletionBadge;